export default {"src":"/_next/static/media/linkedin.3e01f4e6.svg","height":26,"width":26};